import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { deleteStyleGuide, fetchStyleGuides } from "../../redux/actions/styleGuideAction";
import { confirmPopup } from "primereact/confirmpopup";

export default function Index() {
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchStyleGuides());
    }, [dispatch]);

    let { styleGuides } = useSelector((state) => state.style);

    const [search, setSearch] = useState("");

    const getFilteredData = (data, search) => {
        if (search.length) {
            data = data.filter(
                (item) => item?.name?.toLowerCase()?.includes(search.toLowerCase()) || item?.details?.toLowerCase()?.includes(search.toLowerCase())
            );
        }
        return data;
    };

    styleGuides = getFilteredData(styleGuides, search);

    const onDelete = (e, id) => {
        confirmPopup({
            target: e.currentTarget,
            message:
                "Are you sure you want to delete this style? This action will permanently delete the user account. This action cannot be undone.",
            icon: "pi pi-exclamation-triangle",
            accept: () => dispatch(deleteStyleGuide(id)),
            reject: () => {},
        });
    };

    return {
        styleGuides,
        history,
        search,
        setSearch,
        dispatch,
        onDelete,
    };
}
